import type { PImage } from '../../engine/aliases'
import type { IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import type { IIJ } from '../../lib/distanceUtil'
import { l } from '../../lib/imports'
import { mathUtils } from '../../lib/mathUtils-sidecar'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export interface IVoyageMovementIndicator extends IEntity {
  image: PImage
  x: number
  y: number
  timer: number
}

const objs: IVoyageMovementIndicator[] = []
export function getAll() {
  return objs
}

export function create(color: number): IVoyageMovementIndicator {
  let image: PImage = spritesUtil.createImage(
    voyageLayers.getLayers().shipAbove,
    sprites.voyTileIndicators[0],
  )
  image.tint = color

  let obj: IVoyageMovementIndicator = {
    id: -1,
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    image,
    x: 0,
    y: 0,
    timer: 0,
  }
  objs.push(obj)

  return obj
}

export function moveToIJ(obj: IVoyageMovementIndicator, iij: IIJ) {
  let t = voyageTilemap.getSafe(iij.i, iij.j)
  if (t) {
    moveToXY(obj, t.x, t.y)
  }
}

export function moveToXY(obj: IVoyageMovementIndicator, x: number, y: number) {
  obj.x = x
  obj.y = y
  obj.image.x = obj.x
  obj.image.y = obj.y
}

export function kill(obj: IVoyageMovementIndicator) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IVoyageMovementIndicator) {
  let ds = common.getUpdateDeltaScaled()
  //let et = common.getUpdateDeltaScaled()
  obj.timer += ds

  let scale = mathUtils.sineLike(obj.timer, 8, 0, 1)

  let maxTime = 1
  obj.image.alpha = 1 - obj.timer / maxTime

  obj.image.x = obj.x
  obj.image.y = obj.y + scale * 8 - 12
}
